<section class="hvac-account-admin-header hvac-program-search-header">
    <hvac-content-header [data]="heading"></hvac-content-header>
</section>

<section class="hvac-content-container">
    <div class="hvac-whats-new-results-search-container">
    <div class="hvac-whats-new-header">
        <h1 class="hvac-h3">
            {{ 'WHATS_NEW_RESULTS.SEARCH_BY' | translate }}
        </h1>
    </div>

    <form [formGroup]="whatsNewResultsForm">
        <div class="hvac-whats-new-results-filter-container">
            <div class="hvac-whats-new-result-input">
                <h2 class="hvac-header hvac-required">
                    {{ 'WHATS_NEW_RESULTS.BRAND' | translate }}
                </h2>
                <div class="hvac-form-field">
                    <utc-select-checkbox shadow="light" [multiple]="true" [showSelectAll]="true"
                        selectAllLabel="{{ 'WHATS_NEW_RESULTS.SELECT_ALL' | translate }}"
                        [options]="(brandsList$ | async)!" [group]="whatsNewResultsForm" control="brand"
                        defaultOption="{{ 'WHATS_NEW_RESULTS.SELECT_BRAND' | translate }}">
                    </utc-select-checkbox>
                </div>
            </div>
            <div class="hvac-whats-new-result-input">
                <h2 class="hvac-header hvac-required">
                    {{ 'WHATS_NEW_RESULTS.DOCUMENT_TYPE' | translate }}
                </h2>
                <div class="hvac-form-field">
                    <utc-select-checkbox shadow="light" [multiple]="true" [showSelectAll]="true"
                        selectAllLabel="{{ 'WHATS_NEW_RESULTS.SELECT_ALL' | translate }}"
                        [options]="documentTypeOptions" [group]="whatsNewResultsForm" control="documentType"
                        defaultOption="{{ 'WHATS_NEW_RESULTS.SELECT_DOCUMENT' | translate }}">
                    </utc-select-checkbox>
                </div>
            </div>
            <div class="hvac-whats-new-result-input">
                <h2 class="hvac-header hvac-required">
                    {{ 'WHATS_NEW_RESULTS.DATE' | translate }}
                </h2>
                <div class="hvac-form-field">
                    <utc-select shadow="light" [options]="dateOptions" [group]="whatsNewResultsForm" control="date"
                        defaultOption="{{ 'WHATS_NEW_RESULTS.SELECT_DATE' | translate }}"
                        (onChange)="onDateChange($event)">
                    </utc-select>
                </div>
            </div>
            <div *ngIf="showDateRangePicker" class="hvac-whats-new-result-input hvac-date-range">
                <div class="hvac-form-field">
                    <hvac-date-range-picker
                        [startDate]="selectedStartDate"
                        [endDate]="selectedEndDate"
                        [error]=""
                        (onSelection)="setFromToDate({ startDate: $event.startDate, endDate: $event.endDate })"
                        [theme]="'retro'">
                    </hvac-date-range-picker>
                </div>
            </div>
        </div>
        <div class="whats-new-results-search-btn">
            <button type="button" hvacButton="default" class="whats-new-results-clear-button" (click)="clearAll()">
                <span>{{ 'ACCOUNT_ADMIN.CLEAR_ALL' | translate }}</span>
            </button>
            <button hvacbutton="primary" buttonType="submit" class="hvac-button-primary whats-new-results-search-button"
                [disabled]="!whatsNewResultsForm.valid"
                (click)="searchNewResults(whatsNewResultsForm)">
                <span>{{ 'WHATS_NEW_RESULTS.SEARCH_WHATS_NEW_RESULTS' | translate }}</span>
            </button>
        </div>
    </form>
</div>

<div class="hvac-program-table-container">
    <p class="hvac-whats-new-results-count" *ngIf="allSearchResults.length > 0">
        {{ 'ACCOUNT_ADMIN.RESULTS_COUNT' | translate: { totalCount: filteredSearchResults.length } }}
    </p>
    <form *ngIf="allSearchResults.length > 0"
        [formGroup]="resultsFilterForm"
        class="hvac-row hvac-whats-new-results-local-filter">
        <utc-input class="hvac-col-lg-3 hvac-col-md-6 hvac-col-xs-12 hvac-whats-new-local-filter-input"
            type="text"
            shadow="light"
            [inputControl]="resultsFilterForm.controls.title"
            [label]="'WHATS_NEW_RESULTS.SEARCH_RESULTS.TITLE' | translate">
        </utc-input>
        <utc-input class="hvac-col-lg-3 hvac-col-md-6 hvac-col-xs-12 hvac-whats-new-local-filter-input"
            type="text"
            shadow="light"
            [inputControl]="resultsFilterForm.controls.documentType"
            [label]="'WHATS_NEW_RESULTS.SEARCH_RESULTS.DOCUMENT_TYPE' | translate">
        </utc-input>
        <utc-input class="hvac-col-lg-3 hvac-col-md-6 hvac-col-xs-12 hvac-whats-new-local-filter-input"
            type="text"
            shadow="light"
            [inputControl]="resultsFilterForm.controls.catalogNumber"
            [label]="'WHATS_NEW_RESULTS.SEARCH_RESULTS.CATALOG_NUMBER' | translate">
        </utc-input>
    </form>

    <hvac-table class="hvac-program-table-wrap" [theme]="'default'">
        <thead>
            <tr>
                <td>
                    {{ 'WHATS_NEW_RESULTS.SEARCH_RESULTS.TITLE' | translate }}
                </td>
                <td>
                    {{ 'WHATS_NEW_RESULTS.SEARCH_RESULTS.CATALOG_NUMBER' | translate }}
                </td>
                <td>
                    {{ 'WHATS_NEW_RESULTS.SEARCH_RESULTS.BRAND' | translate }}
                </td>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let result of (searchResults$ | async)"
                class="hvac-whats-new-result-row"
                [class.hvac-whats-new-result-row-clickable]="!!result.documentUrl"
                (click)="onResultRowClick(result)">
                <td>
                    <div class="hvac-whats-new-result-title">
                        <div class="hvac-stacked-list-icon">
                            <utc-svg class="hvac-whats-new-result-file-icon" [src]="result.fileIcon"></utc-svg>
                        </div>
                        <div class="hvac-stacked-list-details">
                            <p class="hvac-stacked-list-link-title">{{ result.title }}</p>
                            <div class="hvac-stacked-list-properties">
                                <span *ngIf="result.type">{{ result.type }}</span>
                                <span *ngIf="result.releaseDate">{{ result.releaseDate }}</span>
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    {{ result.catalogNumber }}
                </td>
                <td>
                    {{ result.brands }}
                </td>
            </tr>
        </tbody>
    </hvac-table>
    <p class="hvac-admin-programs-no-results" *ngIf="!(searchResults$ | async)?.length && !loading">{{ 'ACCOUNT_ADMIN.NO_RESULTS' | translate }}</p>
    <utc-loading-spinner spinnerSize="small" *ngIf="loading"></utc-loading-spinner>
    <div class="hvac-pagination">
        <hvac-pagination *ngIf="totalPages > 1" [totalPages]="totalPages" [currentPage]="currentPage"
            (pageChange)="handlePageChange($event)">
        </hvac-pagination>
    </div>
    <div class="whats-new-results-max-results-warning">
        <hvac-toast [name]="'whatsNewResultsMaxSearchResultsLimit'"></hvac-toast>
    </div>
</div>
</section>
